import KmSelect from './select.vue'
KmSelect.install = function (vue) {
  vue.component(KmSelect.name, KmSelect)
}
export default KmSelect



// WEBPACK FOOTER //
// ./src/ui/components/km-select/index.js